import React from "react";
import * as Styles from "./styles/VehicleDetails";
import { TradeInAemLabel } from "../../../utils/labels";
import { useTradeInAemSelector } from "../../../redux/store";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import { TradeInAemSearchType } from "../../../utils/constants";

const VehicleDetailsResult = (): JSX.Element => {
    const csl = useTradeInCsl();
    const vehicleName = useTradeInAemSelector(csl.vehicleNameSelector);
    const value = useTradeInAemSelector(csl.vehiclePlateOrVinSelector);
    const searchType = useTradeInAemSelector((state) => state.tradeInAemFindVehicle.searchType);

    const valueLabel =
        searchType === TradeInAemSearchType.LicensePlate
            ? "tradeInAemVehicleDetailsLicensePlate"
            : "tradeInAemVehicleDetailsVin";

    return (
        <Styles.Card>
            <Styles.CardTitle>{vehicleName.name}</Styles.CardTitle>
            {vehicleName.description && <div>{vehicleName.description}</div>}
            {value && (
                <Styles.License>
                    <Styles.LicenseLabel>
                        <TradeInAemLabel label={valueLabel} />
                    </Styles.LicenseLabel>
                    {value}
                </Styles.License>
            )}
        </Styles.Card>
    );
};
export default VehicleDetailsResult;
